<template>
  <div> 
    <v-navigation-drawer 
      v-model="show" 
      app=""  
      color="b1 darken-0"
      temporary=""
      right="">
      <v-img
          :src="require(`@/assets/awrim/three/t13.jpeg`)"
          :lazy-src="not.imgLazy"
          aspect-ratio="1.8"
          dark>
          <v-overlay absolute="" opacity="0.3"> 
              <v-layout fill-height="" class="white--text " >
                  <div class="not-f8 ">TERESIAN</div>
              </v-layout>
          </v-overlay> 
      </v-img>
      <v-sheet v-if="us"
        tile="" color=" darken-2" dark="">
        <v-list-item>
          <v-list-item-avatar>
            <v-img  :src="require(`@/assets/awrim/three/t13.jpeg`)"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{us.email}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 
      </v-sheet>
      <v-divider></v-divider>   
      <v-list
        dense
        nav >
        <v-list-item 
          to="/">
          <v-list-item-icon>
            <v-icon color="primary">home</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 

         <v-list-item 
          to="/services">
          <v-list-item-icon>
            <v-icon color="primary">mdi-folder-multiple</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Services</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          to="/news">
          <v-list-item-icon>
            <v-icon color="primary">mdi-newspaper</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>News</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item 
          to="/events">
          <v-list-item-icon>
            <v-icon color="primary">mdi-calendar</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Events</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 
        
        <v-list-item 
          to="/communities">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-group</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Communities</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 

        <v-list-item 
          to="/sisters">
          <v-list-item-icon>
            <v-icon color="primary">group</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Sisters</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 
         <v-list-item 
          to="/about">
          <v-list-item-icon>
            <v-icon color="primary">mdi-information-outline</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>About us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
          to="/contact">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-box</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Contact us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item  v-if="!us"
          to="/login">
          <v-list-item-icon>
            <v-icon color="primary">mdi-login</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item  v-if="us"
          to="/cpanel">
          <v-list-item-icon>
            <v-icon color="primary">dashboard</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Cpanel</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

        <v-list-item  v-if="us"
          @click="not.logout()" >
          <v-list-item-icon>
            <v-icon color="primary">mdi-logout</v-icon>
          </v-list-item-icon> 
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content> 
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props:["not","navOpen"],
  data: () => ({
     show: false
  }),
  computed: {
    us(){
      return this.not.us
    }, 
  },
  watch: {
    navOpen(value){ 
      this.show = !this.show   
    },
  },
};
</script>
